<template>
  <v-container class="pt-0">
    <v-app-bar
      elevate-on-scroll
      fixed
      class="pl-14"
      style="background: #a9a9a9"
      v-if="show"
    >
      <v-toolbar-title class="font-weight-medium">{{
        title ? title : "Vue App"
      }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon v-if="isLogged">
        <v-icon @click.prevent="logout">mdi-logout</v-icon>
      </v-btn>

      <v-btn icon v-else to="/login">
        <v-icon>mdi-login</v-icon>
      </v-btn>
    </v-app-bar>
  </v-container>
</template>

<script>
export default {
  name: "PageBar",

  props: {
    isLogged: Boolean,
    title: String,
    show: Boolean,
  },

  data: () => ({}),

  methods: {
    logout() {
      this.$emit("event");
    },
  },

  mounted() {},
};
</script>
